@if(currentRegionData) {
@switch (deskmode) {
@case ('xs') {
<ng-container *ngTemplateOutlet="modexssm"></ng-container>
}
@case ('sm') {
<ng-container *ngTemplateOutlet="modexssm"></ng-container>
}
@default {
<ng-container *ngTemplateOutlet="modelgxl"></ng-container>
}
}
}

<ng-template #modelgxl>
    <div class="g-wrapper">
        <div class="t-wrapper" (click)="toggleOpen()">
            <h2 multilang class="h2-body">
                <div class="h2-text-wrapper">
                    <mat-icon>explore</mat-icon> <span multilang class="mleft">Reisekompass zum Land</span> <b
                        class="mleft">{{country}}</b> <span multilang class="extra-t"> (hier finden Sie alle
                        wichtigen
                        Ein- und
                        Ausreisebestimmungen)</span>
                </div>
            </h2>
            @if(open) {
            <mat-icon class="icom">expand_less
            </mat-icon>
            } @else {
            <mat-icon class="icom">expand_more
            </mat-icon>
            }
        </div>
        @if(open) {
        <ng-container *ngTemplateOutlet="content"></ng-container>
        }
    </div>
</ng-template>

<ng-template #modexssm>
    <div class="g-wrapper-mobile">
        <div class="t-wrapper" (click)="toggleOpen()">
            <span multilang class="h2-body">
                <div class="h2-text-wrapper">
                    <mat-icon>explore</mat-icon> <span multilang class="mleft">Reisekompass zum Land</span> <b
                        class="mleft">{{country}}</b>
                </div>
            </span>
            @if(open) {
            <mat-icon class="icom">expand_less
            </mat-icon>
            } @else {
            <mat-icon class="icom">expand_more
            </mat-icon>
            }
        </div>
        <ng-container *ngIf="open" [ngTemplateOutlet]="content"></ng-container>
    </div>
</ng-template>

<ng-template #content>
    <div style="display: flex;align-items: center;justify-content: center;height: calc(100% - 1rem);border-radius: 0.5rem;padding: .5rem;"
        id="coronamapcompass">
        <div
            style="display: flex;position: relative;border-radius: 0.5rem;min-height: max-content;width: 100%;height: 100%;max-width: 1230px;">
            <ng-container *ngIf="!loading else myloading">
                <div style="display: flex;flex-direction: column;">
                    <div
                        style="display: flex; width: 100%;flex-direction: column;border-radius: 0.5rem;justify-content: space-between;height: 100%;">
                        <div style="display: flex;flex-direction: column;height: max-content;overflow: hidden;">
                            <div class="gwrapper">
                                <div style="display: flex;flex-direction: column;width: 100%;">
                                    <!-- <ng-container *ngIf="currentRegionData?.statusrki">
                                        <div class="wrapper noselect" style="min-height: 70px;">
                                            <ng-container *ngIf="!loading">
                                                <app-statusrki [currentRegionData]="currentRegionData">
                                                </app-statusrki>
                                            </ng-container>
                                        </div>
                                    </ng-container>
                                    <ng-container *ngIf="
                                currentRegionData.onentry?.show_covid_19_test ||
                                currentRegionData.quarantine_on_entry ||
                                (currentRegionData?.einreisenmit && !currentRegionData?.einreisenmitisAutovonLand) ||
                                currentRegionData.onentry?.registration">
                                        <div class="wrapper" style="min-height: 70px;">
                                            <ng-container *ngIf="!loading">
                                                <app-einurlland [currentRegionData]="currentRegionData">
                                                </app-einurlland>
                                            </ng-container>
                                        </div>
                                    </ng-container>
                                    <ng-container
                                        *ngIf="currentRegionData?.inzidenz || currentRegionData?.inzidenzLand">
                                        <div class="wrapper">
                                            <ng-container *ngIf="!loading">
                                                <app-inzidenz [currentRegionData]="currentRegionData"
                                                    [chartOption]="chartOption"></app-inzidenz>
                                            </ng-container>
                                        </div>
                                    </ng-container>
                                    <ng-container *ngIf="currentRegionData?.statusrki">
                                        <div class="wrapper">
                                            <app-einnachdeusch [currentRegionData]="currentRegionData"
                                                [deskmode]="deskmode"></app-einnachdeusch>
                                        </div>
                                    </ng-container>
                                    <ng-container *ngIf="countryupdate?.length > 0">
                                        <div class="wrapper" id='coronaupdateinfo'>
                                            <ng-container *ngIf="!loading">
                                                <app-coronaupdates [countryupdate]="countryupdate">
                                                </app-coronaupdates>
                                            </ng-container>
                                        </div>
                                    </ng-container> -->
                                    <div class="wrapper">
                                        @if(passolutionLoading()) {
                                        <ng-container *ngTemplateOutlet="myloading"></ng-container>
                                        } @else {
                                            <app-ausamt [currentRegionData]="currentRegionData"
                                                [passolutionData]="passolution()" [deskmode]="deskmode">
                                            </app-ausamt>
                                        }
                                    </div>

                                    <div class="wrapper">
                                        <app-regelungen></app-regelungen>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-container>
        </div>
    </div>

    <ng-template #myloading>
        <div style="display: flex;flex-direction: column;width: 100%;margin-top:.5rem;padding:.5rem;">
            <div style="width:20%;height:30px; border-radius: .3rem;" class="skeleton"></div>
            <div style="width:100%;height:30px; border-radius: .3rem;margin-top: .5rem;" class="skeleton"></div>
            <div style="width:100%;height:30px; border-radius: .3rem;margin-top: .5rem;" class="skeleton"></div>
            <div style="width:100%;height:30px; border-radius: .3rem;margin-top: .5rem;" class="skeleton"></div>
            <div style="width:100%;height:30px; border-radius: .3rem;margin-top: .5rem;" class="skeleton"></div>
        </div>
    </ng-template>
    <mat-divider></mat-divider>

    <div style="display: flex;
                    min-height: 40px;
                    flex-direction: row;
                    position: relative;
                    max-width: 1541px;
                    width: 100%;
                    margin: 0 auto;
                    justify-content: center;
                    align-items: center;
                    cursor: pointer;" (click)="scrollToTop();">
        <h3 multilang style="display: flex;align-items: center;margin: 0.5rem 0 0.5rem 0;font-weight: 400;">
            Schließen
        </h3>
        <mat-icon>expand_less</mat-icon>
    </div>
</ng-template>
